// extracted by mini-css-extract-plugin
export var addButton = "_mx-0";
export var border = "_mx-8";
export var check = "_mx-h";
export var danger = "_mx-6";
export var dropdownContainer = "_mx-1";
export var editModalBody = "_mx-j";
export var footerContainer = "_mx-i";
export var fullWidth = "_mx-a";
export var hide = "_mx-9";
export var icon = "_mx-3";
export var input = "_mx-7";
export var inputFlex = "_mx-b";
export var inputWrapper = "_mx-c";
export var manualFocus = "_mx-5";
export var optionButton = "_mx-4";
export var pillWrapper = "_mx-e";
export var pointer = "_mx-2";
export var showOverflow = "_mx-f";
export var tagsFlex = "_mx-d";
export var xButton = "_mx-g";